import { useEffect, useState } from 'react';
import { ListResource } from '../../components';
import { useColumns } from './columns';
import { ExtraFilters } from './ExtraFilters';
import { useFormatter } from '../../utils/formatter';
import { useListWithAddressFilters } from './utils/useListWithAddressFilters';

/**
 * `ListOwners` is a component that displays a list of owner records. It allows filtering the list
 * based on city and department (state). The component leverages the `ListResource` component and
 * provides specific columns, filtering options, and actions for managing owner records.
 *
 * @component
 * @returns {React.Element} A JSX element displaying a list of owner records with filtering options.
 */
export const ListOwners = () => {
  const [forceRefresh, setForceRefresh] = useState(false);
  const { formattedData } = useFormatter();
  const { columns, headers } = useColumns(setForceRefresh);
  const {
    cityOptions,
    departmentOptions,
    setCityFilter,
    setDepartmentFilter,
    isFieldsLoading,
    extraQuery
  } = useListWithAddressFilters('owners');

  useEffect(() => {
    if (forceRefresh) {
      setForceRefresh(false);
    }
  }, [forceRefresh]);

  return (
    <ListResource
      resourceName="owners"
      columns={columns}
      headers={headers}
      resourceModelName="Owner"
      withArchiveButton
      extraQuery={extraQuery}
      customActionColumn
      forceRefresh={forceRefresh}
      formatter={formattedData}
      withoutImportButton
      scroll={{ x: 1000 }}
      extraFilters={
        <ExtraFilters
          isFieldsLoading={isFieldsLoading}
          cityOptions={cityOptions}
          departmentOptions={departmentOptions}
          setCityFilter={setCityFilter}
          setDepartmentFilter={setDepartmentFilter}
          translationKey="owners"
        />
      }
      backIcon={false}
    />
  );
};
